<header>
  <app-header></app-header>
</header>

<div class="outer-conatiner">
  <div class="inner-container form-container">
    <div class="code-enf-wrapper ">
      <div class="display-flex">
        <app-page-title class="test" pageTitle='Create Case'>
        </app-page-title>
      </div>
      <div>
        <form [formGroup]="createCaseForm" (ngSubmit)="onSubmit()">
          <div class="col-10 form-block">
            <mat-form-field class="mat-date-pick" style="width:110%;">
              <mat-label>Violation</mat-label>
              <!-- <input matInput formControlName="state"/> -->
              <mat-select formControlName="violationId" required>
                <mat-option *ngFor="let violation of violations" [value]="violation.id">{{violation.violation}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="createCaseForm.get('violationId').hasError('required')">
                Please select violation
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width:110%;"
              *ngIf="otherReasonForViolation && (createCaseForm.controls.violationId.value == otherReasonForViolation[0].id)">
              <mat-label>Add new violation</mat-label>
              <input matInput formControlName="otherReasonForViolation" pattern="^[a-zA-Z]+.*?[^\s]$" type="text" />
              <mat-error *ngIf="createCaseForm.get('otherReasonForViolation').hasError('required')">
                Please provide new violation
              </mat-error>
              <mat-error
                *ngIf="!createCaseForm.get('otherReasonForViolation').hasError('required') && createCaseForm.get('otherReasonForViolation').hasError('pattern')">
                Violation should be alphanumeric without begenning spaces.
              </mat-error>
            </mat-form-field>
            <!-- <p style="color:red; display: flex; margin: auto; font-size: 75%;" *ngIf="!createCaseForm.get('otherReasonForViolation').hasError('required') && violationAlreasyExists">
              Violation already exists
            </p> -->
            <mat-error style="text-align: left; font-size: 75%; margin-top: -13px;" *ngIf="!createCaseForm.get('otherReasonForViolation').hasError('required') && violationAlreasyExists">
              Violation already exists
            </mat-error>
          </div>
          <div class="col-10 form-block">
            <mat-form-field class="mat-date-pick" style="width:110%;">
              <mat-label>Days to cure</mat-label>
              <!-- <input matInput formControlName="state"/> -->
              <mat-select  formControlName="daysToCureId" required>
                <mat-option *ngFor="let day of days" [value]="day.id">{{day.numberOfDays}}</mat-option>
              </mat-select>
              <mat-error *ngIf="createCaseForm.get('daysToCureId').hasError('required')">
                Please select number of days
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width:110%;"
              *ngIf="otherReasonForDays && (createCaseForm.controls.daysToCureId.value == otherReasonForDays[0].id)">
              <mat-label>Add new days</mat-label>
              <input pattern="^[1-9]{1,2}[:.,-]?$" type="number" min="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57" matInput
                formControlName="otherReasonForDays" />
              <mat-error *ngIf="createCaseForm.get('otherReasonForDays').hasError('required')">
                Please provide new Days
              </mat-error>
              <mat-error *ngIf="!createCaseForm.get('otherReasonForDays').hasError('required') && createCaseForm.controls['otherReasonForDays'].hasError('pattern') && !daysToCureAlreasyExists">
                Maxlength is 2.
               </mat-error>
              <!-- <mat-error *ngIf="createCaseForm.controls['otherReasonForDays'].hasError('min')">
                You are not allowed to add decimals.
              </mat-error> -->
            </mat-form-field>
            <!-- <p style="color:red; display: flex; margin: auto;font-size: 75%;" *ngIf="!createCaseForm.get('otherReasonForDays').hasError('required') && daysToCureAlreasyExists">
              Days already exists
            </p> -->
            <mat-error style="text-align: left; font-size: 75%; margin-top: -13px;" *ngIf="!createCaseForm.get('otherReasonForDays').hasError('required') && otherReasonForDays && createCaseForm.controls.daysToCureId.value == otherReasonForDays[0].id && createCaseForm.controls.otherReasonForDays.value == 0">
              Please select valid number of days
            </mat-error>
            <mat-error style="text-align: left; font-size: 75%; margin-top: -13px;" *ngIf="!createCaseForm.get('otherReasonForDays').hasError('required') && daysToCureAlreasyExists">
              Days already exists
            </mat-error>
          </div>
          <div class="col-10 form-block">
            <mat-form-field class="mat-date-pick" style="width:110%;">
              <mat-label>Category</mat-label>
              <!-- <input matInput formControlName="state"/> -->
              <mat-select formControlName="categoryId" required>
                <mat-option *ngFor="let category of categories" [value]="category.id">{{category.category}}</mat-option>
              </mat-select>
              <mat-error *ngIf="createCaseForm.get('categoryId').hasError('required')">
                Please select category
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width:110%;"
              *ngIf="otherReasonForCategories && (createCaseForm.controls.categoryId.value == otherReasonForCategories[0].id)">
              <mat-label>Add new category</mat-label>
              <input matInput formControlName="otherReasonForCategories" pattern="^[a-zA-Z]+.*?[^\s]$" />
              <mat-error *ngIf="createCaseForm.get('otherReasonForCategories').hasError('required')">
                Please provide new category
              </mat-error>
              <mat-error
                *ngIf="!createCaseForm.get('otherReasonForCategories').hasError('required') && createCaseForm.get('otherReasonForCategories').hasError('pattern')">
                Category should be alphanumeric without begenning spaces.
              </mat-error>
            </mat-form-field>
            <!-- <span style="color:red; display: flex; margin: auto;font-size: 75%;" *ngIf="!createCaseForm.get('otherReasonForCategories').hasError('required') && categoryAlreasyExists">
              Category already exists
            </span> -->
            <mat-error style="text-align: left; font-size: 75%; margin-top: -13px;" *ngIf="!createCaseForm.get('otherReasonForCategories').hasError('required') && categoryAlreasyExists">
              Category already exists
            </mat-error>
          </div>
          <div class="row">
            <div class="col-6 row-cols">
              <mat-form-field class="mat-date-pick" style="width:97%;">
                <mat-label>Street No.</mat-label>
                <input matInput formControlName="streetNumber" type="text" pattern="^(?![\s-])[\w -]+$" required />
                <mat-error *ngIf="createCaseForm.get('streetNumber').hasError('required')">
                  Please enter Street number
                </mat-error>
                <mat-error
                  *ngIf="!createCaseForm.get('streetNumber').hasError('required') && createCaseForm.get('streetNumber').hasError('pattern')">
                  Street.No. should be alphanumeric without spaces.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6 row-cols">
              <mat-form-field class="mat-date-pick" style="width:120%;">
                <mat-label>Street</mat-label>
                <!-- <input matInput formControlName="state"/> -->
                <mat-select formControlName="streetId" required>
                  <mat-option *ngFor="let street of streets" [value]="street.id">{{street.street}}</mat-option>
                </mat-select>
                <mat-error *ngIf="createCaseForm.get('streetId').hasError('required')">
                  Please select street
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-4 display-flex">
            <button mat-button class="button-primary"
              [disabled]='createCaseForm.invalid || btnDisabled || (otherReasonForDays && (createCaseForm.controls.daysToCureId.value == otherReasonForDays[0].id) && createCaseForm.controls.otherReasonForDays.value <= 0) || categoryAlreasyExists || daysToCureAlreasyExists || violationAlreasyExists || popupOpend'
              color="vov-ui-primary">Create case</button>
            <span><button style="padding-top:51px;" type="reset" class="semi-button semi-reset" color="vov-ui-primary"
                (click)="reset()">Reset</button></span>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #confirmRef>
  <div class="dialog-Container">
    <h3 mat-dialog-title style="font-size: initial;">Case already exists with details, do you want to continue? If yes, please click on "Ok" else click on "Cancel".</h3>
    <mat-dialog-content class="delete-Conatiner">
      <button mat-button color="vov-ui-primary" class="confirm-btn confirm" (click)="confirm()">Ok</button>
      <button mat-button (click)="onNoClick()" class="confirm-btn cancel" tabindex="-1">Cancel</button>
    </mat-dialog-content>
  </div>
</ng-template>
